import { get } from "lodash-es";

export function sortBy<T>(a: T, b: T, key: GlobalTypes.ExtractNonObjectKeys<T>): number {
	const aValue = get(a, key);
	const bValue = get(b, key);

	if (typeof aValue === "string" && typeof bValue === "string") {
		return (aValue as string).localeCompare(bValue);
	}

	if (typeof aValue === "number" && typeof bValue === "number") {
		return (aValue as number) - (bValue as number);
	}

	if (typeof aValue === "boolean" && typeof bValue === "boolean") {
		// eslint-disable-next-line @typescript-eslint/no-magic-numbers
		return aValue ? 1 : -1;
	}

	if (aValue instanceof Date && bValue instanceof Date) {
		return aValue.getTime() - bValue.getTime();
	}

	// eslint-disable-next-line @typescript-eslint/no-magic-numbers
	return 1;
}
